import {Pipe, PipeTransform} from '@angular/core';
import { InvoiceData } from '../pipes/billing.model';
@Pipe({
 name: 'dateSortPipe'
})
export class DateSortPipe implements PipeTransform{  

 transform(array: Array<InvoiceData>): Array<InvoiceData> {

  if(!array || array === undefined || array.length === 0) return null;

    array.sort((a: any, b: any) => {
      if (a.invoiceCreatedDate < b.invoiceCreatedDate) {
        return -1;
      } else if (a.invoiceCreatedDate > b.invoiceCreatedDate) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/date-sort.pipe.ts